<template>
    <Breadcrumbs main="Bootstrap Tables" title="Bootstrap Basic Tables" />
    <div class="container-fluid basic_table">
        <div class="row">
            <basicTable />
            <inverseTable />
            <hoverableTable />
            <primaryBackground />
            <captionTable />
            <headOptions />
            <stripedRow />
            <breckpointSpecific />
            <responsiveTable />
            <sizingTable />
            <customTable />
            <dashedBorder />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const basicTable = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/basicTable.vue"))
const inverseTable = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/inverseTable.vue"))
const hoverableTable = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/hoverableTable.vue"))
const primaryBackground = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/primaryBackground.vue"))
const captionTable = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/captionTable.vue"))
const headOptions = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/headOptions.vue"))
const stripedRow = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/stripedRow.vue"))
const breckpointSpecific = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/breckpointSpecific.vue"))
const responsiveTable = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/responsiveTable.vue"))
const sizingTable = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/sizingTable.vue"))
const customTable = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/customTable.vue"))
const dashedBorder = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/dashedBorder.vue"))
</script>